const Footer = () => {
  return (
    <footer className="py-8 px-6 border-t border-[#C5A059]/10 bg-[#E8D2B5]/80">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-xs text-[#3F2A24] tracking-wide">
          Jeinar <span className="text-[#3F2A24]/40">–</span> The Swiss Source
          <br />
          Gardienne du <span className="italic">Cocon</span> <span className="text-[#3F2A24]/40">|</span> Passeuse des Fréquences du Vivant
        </p>
      </div>
    </footer>
  );
};

export default Footer;